import { Routes } from '@angular/router';
import { mcTripsStaffGuard } from './auth/mc-trips-staff.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./auth/mc-trips-sign-in-page.component').then((m) => m.McTripsSignInPageComponent),
  },
  {
    path: '',
    canActivate: [mcTripsStaffGuard],
    loadComponent: () => import('./layout/layout.component').then((m) => m.LayoutComponent),
    children: [
      { path: '', loadComponent: () => import('./home/home.component').then((m) => m.HomeComponent) },
      {
        path: 'my-trips',
        loadComponent: () => import('./trips/trips.component').then((m) => m.TripsComponent),
      },
      // Same paths as main app (trip-leading/journals/...) — TripJournalsHomeComponent uses these routerLinks.
      {
        path: 'trip-leading',
        children: [
          {
            path: 'journals',
            loadComponent: () => import('@incident-management').then((m) => m.TripJournalsHomeComponent),
            data: { title: 'Trip Journals' },
          },
          {
            path: 'journals/:tripId',
            loadComponent: () => import('@incident-management').then((m) => m.TripJournalComponent),
            data: { title: 'Trip Journal' },
          },
        ],
      },
      // Aliases for mc-trips nav (SeasonalNavItem routerLink: 'trip-journals').
      {
        path: 'trip-journals',
        loadComponent: () => import('@incident-management').then((m) => m.TripJournalsHomeComponent),
        data: { title: 'Trip Journals' },
      },
      {
        path: 'trip-journals/:tripId',
        loadComponent: () => import('@incident-management').then((m) => m.TripJournalComponent),
        data: { title: 'Trip Journal' },
      },
      {
        path: 'flights',
        loadComponent: () => import('./flights/flights.component').then((m) => m.FlightsComponent),
        data: { title: 'Mission Trip Flight Info' },
      },
      {
        path: 'document-library',
        loadComponent: () =>
          import('./document-library/document-library.component').then((m) => m.DocumentLibraryComponent),
      },
      {
        path: 'leader-guide',
        loadComponent: () =>
          import('./leader-guide/leader-guide.component').then((m) => m.LeaderGuideComponent),
        data: { title: 'Leadership Handbook' },
      },
      {
        path: 'leader-guide/:pageNumber',
        loadComponent: () =>
          import('./leader-guide/leader-guide.component').then((m) => m.LeaderGuideComponent),
        data: { title: 'Leadership Handbook' },
      },
      {
        path: 'pelican-guide',
        loadComponent: () =>
          import('./pelican-guide/pelican-guide.component').then((m) => m.PelicanGuideComponent),
        data: { title: 'Pelican Guide App' },
      },
      {
        path: 'pelican-guide/:guideYear/:pageNumber',
        loadComponent: () =>
          import('./pelican-guide/pelican-guide.component').then((m) => m.PelicanGuideComponent),
        data: { title: 'Pelican Guide App' },
      },
      {
        path: 'team-check-in',
        loadChildren: () => import('./team-check-in/team-check-in.routes').then((m) => m.TEAM_CHECK_IN_ROUTES),
        data: { title: 'Team Check-In' },
      },
      {
        path: 'faqs',
        loadComponent: () => import('./faqs/faqs.component').then((m) => m.FaqsComponent),
        data: { title: 'FAQs' },
      },
      {
        path: 'evals',
        loadComponent: () => import('./evals/evals.component').then((m) => m.EvalsComponent),
        data: { title: 'Post Trip Report' },
      },
      {
        path: 'forms',
        loadChildren: () =>
          import('./forms/mc-trips-forms.routes').then((m) => m.MC_TRIPS_FORMS_ROUTES),
      },
      {
        path: 'incidents',
        loadChildren: () => import('@incident-management').then((m) => m.IncidentsModule),
      },
      {
        path: 'account/emergency-contacts',
        loadComponent: () =>
          import('./account/emergency-contacts/emergency-contacts.component').then(
            (m) => m.EmergencyContactsComponent
          ),
        data: { title: 'Manage Emergency Contacts' },
      },
      {
        path: 'account/profile-photo',
        loadComponent: () =>
          import('./account/profile-photo/profile-photo.component').then((m) => m.ProfilePhotoComponent),
        data: { title: 'Update Profile Photo' },
      },
    ],
  },
];
